import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue } from "firebase/database";

let fbDatabase = null

const setFirebaseConfig = (QSenv) => {
  let qsTmp = QSenv
  if (qsTmp && isNaN(qsTmp)) {
    qsTmp = QSenv.toUpperCase()
  }
  let config = {}
  switch (qsTmp) {
    case 'A':
      config = {
        apiKey: process.env.VUE_APP_A_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_A_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_A_FIREBASE_DATABASE_URL,
        projectId: process.env.VUE_APP_A_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_A_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_A_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_A_FIREBASE_APP_ID
      }
      break
    case 'B':
      config = {
        apiKey: process.env.VUE_APP_B_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_B_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_B_FIREBASE_DATABASE_URL,
        projectId: process.env.VUE_APP_B_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_B_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_B_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_B_FIREBASE_APP_ID
      }
      break
    default:
      config = {
        apiKey: process.env.VUE_APP_A_FIREBASE_API_KEY,
        authDomain: process.env.VUE_APP_A_FIREBASE_AUTH_DOMAIN,
        databaseURL: process.env.VUE_APP_A_FIREBASE_DATABASE_URL,
        projectId: process.env.VUE_APP_A_FIREBASE_PROJECT_ID,
        storageBucket: process.env.VUE_APP_A_FIREBASE_STORAGE_BUCKET,
        messagingSenderId: process.env.VUE_APP_A_FIREBASE_MESSAGING_SENDER_ID,
        appId: process.env.VUE_APP_A_FIREBASE_APP_ID
      }
  }
  // console.log(config)s
  const FirebaseApp = initializeApp(config)
  fbDatabase = getDatabase(FirebaseApp)
}

const setFirebaseRoom = (uid, channel, token) => {
  const path = `users/${uid}/telessaude/sala/${uid}`
  set(ref(fbDatabase, path), { uid: uid, channel, token });
}

const removeFirebaseRoom = (uid) => {
  const path = `users/${uid}/telessaude/sala/${uid}`
  set(ref(fbDatabase, path), { uid: null, channel: null, token: null });
}

const onCallRoom = (id, call) => {
  const path = `videoconferencia/sala/${id}`
  onValue(ref(fbDatabase, path), (snapshot) => {
    const data = snapshot.val();
    call(data)
  });
}

const removeCallRoom = (id) => {
  console.log('id', id)
  const path = `videoconferencia/sala/${id}`
  console.log('path', path)
  set(ref(fbDatabase, path), { cpf: null });
}

export default {
  setFirebaseRoom,
  removeFirebaseRoom,
  onCallRoom,
  removeCallRoom,
  setFirebaseConfig
}